import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ROUTE_ID_DP_END_LOADING = 'GET_ROUTE_ID_DP_END_LOADING';
export const GET_ROUTE_ID_DP_END_SUCCESS = 'GET_ROUTE_ID_DP_END_SUCCESS';
export const GET_ROUTE_ID_DP_END_REJECT = 'GET_ROUTE_ID_DP_END_REJECT';

//* ACTIONS ------------------------------------------------
export const getRouteIdDPEndLoading = () => ({ type: GET_ROUTE_ID_DP_END_LOADING });
export const getRouteIdDPEndSuccess = (payload) => ({ type: GET_ROUTE_ID_DP_END_SUCCESS, payload });
export const getRouteIdDPEndReject = (payload) => ({ type: GET_ROUTE_ID_DP_END_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getRouteIdDPEndRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.GET,
        data,
    }, getState);
    return request(`/Route/web/GetRouteEndDeliveryPointByCustomerId?CustomerId=${data.customerId}&MuniId=${data.muniId}&DivisionId=${data.divisionId}`, options);
};
